import(/* webpackMode: "eager", webpackExports: ["GrammarText","GrammarScriptProvider","GrammarScriptToggle"] */ "/app/components/grammar/grammar-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GrammarExampleSaveButton","GrammarStoryProgressBadge","GrammarIndexProgressProvider","GrammarIndexStatusBadge","GrammarProgressControl"] */ "/app/components/grammar/grammar-study-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/app/components/layout/product-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
